import React from 'react';
import { createOptions } from '../../utils/utils';
const DropDown = (props) => {
    let customhref = props.customhref;
    let customTitle = props.customTitle;

    return (
        <React.Fragment>
            <div className="d-block"><label>{props.label}{props.required ? <span className="mandatory">* &nbsp;  <span className="error-msg">{props.error}</span></span> : null}</label></div>
            <div className='form-group input-group'>

                <select className={props.error ? 'is-invalid form-control' : 'form-control'} name={props.name} value={props.value} onChange={props.onChange} disabled={props.disabled || false} readOnly={props.disabled || false}>
                    {createOptions(props.list, props.valProp, props.textProp, props.defaultItem)}
                </select>
                <div className="input-group-append">
                    <span className="input-group-text" id="basic-addon2">
                        <a title={customTitle} className="text-black" href={customhref} download={true}><i className="nav-icon fa fa-download"></i></a>
                    </span>
                </div>

            </div>

        </React.Fragment>
    )
}
export default DropDown;